import { useMemo } from 'react'
import { isOfferRatingDisplayable } from 'lib/order/reviewUtils'
import { logNewRelic } from 'services/newRelic'

function useOfferRating(
  offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary | App.VillaOffer | App.VillaOfferSummary,
  offerListMeta: App.OfferListMetaData | undefined,
): App.OfferRating | undefined {
  const type = offer.type === 'bedbank_hotel' ? 'bedbank' : 'luxuryescapes'
  const property = offer.property

  return useMemo(() => {
    if (!isRatingConsistent(offerListMeta?.rating, property.rating)) {
      logNewRelic('Offer rating inconsistency detected', {
        offerId: offer.id,
        propertyId: property.id,
        type,
        searchRating: offerListMeta?.rating,
        publicOfferRating: property.rating,
      }, 'warn')
    }

    if (offerListMeta?.rating) {
      return {
        score: offerListMeta.rating.score,
        reviewsTotal: offerListMeta.rating.totalReviews,
      } as App.OfferRating
    }
  }, [offerListMeta?.rating, property, type, offer.id])
}

function isRatingConsistent(
  offerSearchRating: App.OfferListMetaData['rating'] | undefined,
  propertyRating: App.OfferRating | undefined,
): boolean {
  const isRatingDisplayable = isOfferRatingDisplayable(propertyRating)

  if (!offerSearchRating && !isRatingDisplayable) return true
  if (!offerSearchRating || !isRatingDisplayable) return false

  return (
    offerSearchRating.score === propertyRating.score &&
    offerSearchRating.totalReviews === propertyRating.reviewsTotal
  )
}

export default useOfferRating
